module.exports = __webpack_public_path__ + "static/blue2-b287ce18618ec171c60a9d8ff8cc638c.png";